import React from 'react';
import { Box } from '@withjoy/joykit';

/**
 * TourBackdrop - Backdrop overlay component
 *
 * Renders a semi-transparent backdrop when the tour is open but the step is not yet ready.
 * This provides visual feedback that the tour is active.
 */
export const TourBackdrop: React.FC = () => {
  return (
    <Box
      position="fixed"
      inset={0}
      zIndex="popover"
      pointerEvents="auto"
      opacity={1}
      background="rgba(0, 0, 0, 0.1)"
    />
  );
};

TourBackdrop.displayName = 'TourBackdrop';
